<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/products'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>
<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { BinLocationTypeService } from "../../../_services/api/settings/products/bin-location-type.service";
import { BinLocationService } from "../../../_services/api/settings/products/bin-location.service";

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        SetDefault: true,
        Inactive: true,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
        BinLocationTypeRecordId: undefined,
      },
      data: {
        title: "Bin Location",
        pageRoute: "/bin-location",
        saveEndPoint: "BinLocation",
        updateEndPoint: "BinLocation",
        recordEndPoint: "BinLocation",
        updateKeyField: "Code",
        // isDefaultEndPoint: "BinLocationType/SaveDefault",
        exportFileName: "Bin Location",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "BinLocationList",
              filter: "",
              select: [
                "Code",
                "Location",
                "Site",
                "Inactive",
                "BinLocationTypeDescription",
                "BinLocationTypeCode",
              ],
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "bin-location",
              mode: "review",
              idProperty: "Code",
              // idMode: "Guid",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/bin-location/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "BinLocation",
            },
            {
              screenField: "BinLocationType",
              gridDataField: "BinLocationTypeDescription",
              cellTemplate: "Record",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "BinLocationTypeDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "BinLocationTypeCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "BinLocationTypeCode",
                  label: "Type Code",
                },
                {
                  dataField: "BinLocationTypeDescription",
                  label: "Type Description",
                },
              ],
            },
            {
              screenField: "Site",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
            },
          ],
          valueChangedEventListners: [],
        },
        recordPostProcess: this.recordPostProcess,
      },
      updatedDefaultRecordId: undefined,
    };
  },
  computed: {
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged: (e) => {
                  this.onActiveValueChanged(e);
                },
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formHeight: 150,
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                editorOptions: {
                  maxLength: 4,
                },
                required: true,
                screenField: "Code",
                isPrimaryKeyField: true,
                label: { text: "Code" },
                visible: true,
                allowUpdate: this.baseView.mode == "create",
              },
              {
                dataField: "Location",
                label: { text: "Location" },
                required: true,
                allowUpdate: this.baseView.mode !== "review",
                screenField: "Code",
                isPrimaryKeyField: true,
              },
              {
                dataField: "Site",
                label: { text: "Site" },
                // required: true,
                allowUpdate: this.baseView.mode !== "review",
                screenField: "Code",
                isPrimaryKeyField: true,
              },
              {
                screenField: "BinLocationType",
                required: true,
                dataField: "BinLocationTypeRecordId",
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        this.setLoading = true;
        BinLocationService.getProductBinLocation(
          `BinLocationCode eq '${this.baseView.id}'`
        )
          .then((res) => {
            this.setLoading = false;
            if (res.data.value.length > 0) {
              this.formModel.Inactive = true;
              e.component.beginUpdate();
              e.component.option("value", true);
              e.component.endUpdate();
              this.validationSummary = [];
              this.validationSummary.push({
                message: `${this.baseView.id} : ${this.formModel.Location} is associated with product records. This may not be marked inactive until it is no longer associated with product records.`,
              });
              // this.validationSummary.push({
              //   message: `Tip: To identify the associated product use the filters on the product list.`,
              // });
            }
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      }
    },
    recordPostProcess(data) {
      if (this.baseView.mode == "create") {
        BinLocationTypeService.getDefaultType().then((res) => {
          if (res.data.value.length > 0) {
            data.BinLocationTypeRecordId = res.data.value[0].RecordId;
          }
        });
      }

      return data;
    },
  },
  async created() {
    this.recordPostProcess(this.formModel);
  },
};
</script>
